import { useSortingStore } from "@/Stores/sorting";
import { computed } from "vue";

export function useSorting(storeKey) {
    const sortingStore = useSortingStore();

    const sortBy = computed(() => {
        return sortingStore[storeKey]?.id || "created_at";
    });

    const orderBy = computed(() => {
        if (sortingStore[storeKey].length === 0) {
            return "desc";
        }

        return sortingStore[storeKey]?.desc ? "desc" : "asc";
    });

    const sortingValues = computed(() => {
        return {
            sort_by: sortBy.value,
            order_by: orderBy.value,
        };
    });

    const sortingValuesRaw = computed(() => {
        return sortingStore[storeKey];
    });

    const handleSortingChange = (value) => {
        if (!sortingStore[storeKey]) {
            console.error(
                "The specified store key is not present in the sorting store."
            );
        }

        if (JSON.stringify(sortingStore[storeKey]) === JSON.stringify(value)) {
            return;
        }

        sortingStore[storeKey] = value;
    };

    const handleClearSorting = () => {
        sortingStore[storeKey] = [];
    };

    return {
        sortBy,
        orderBy,
        sortingValues,
        sortingValuesRaw,
        handleSortingChange,
        handleClearSorting,
    };
}
